import { useDispatch, useSelector } from "react-redux";
import { Select, Option, Button, Tooltip } from "../../../common/HarmonyEnablers";
import { getTenantDisplayLabel } from "../../../shared-components/app-personas/AppPersona.selectors.redux";
import { SqlConnection } from "../../../model/connections/SqlConnection.model";
import { Icon, TextField } from "../ConnectionScope";
import "../connections.css"
import { AppDispatch, RootState } from "../../../root-redux/RootState";
import { postConnections } from "../../../services/PostConnections.api";
import { ConnectionType } from "../../../model/connections/ConnectionType.model";
import { useEffect, useState } from "react";
import { withErrorBoundary } from "../../../shared-components/ErrorBoundary";
import { Connection } from "../../../model/connections/Connection.model";


const SqlConnectionPanelC: React.FC<{connectionData: SqlConnection, editMode: boolean, appScopes: string[] | undefined, connectionType: ConnectionType, subscriptions: {key: string, name: string}[], authType:string}> = ({connectionData, editMode, appScopes, connectionType, subscriptions, authType}) => {
    const dispatch = useDispatch<AppDispatch>()
    const [data, setData] = useState<SqlConnection>(connectionData);
    const selectedEnv =  useSelector((state: RootState) => state.env.selectedEnvItem);

    const adbScopeDev = "https://adb-5404863101054673.13.azuredatabricks.net/?o=5404863101054673#secrets/createScope";
    const adbScopUat = "https://adb-2987319840690271.11.azuredatabricks.net/?o=2987319840690271#secrets/createScope";
    const adbScopProd = "https://adb-5011763184037517.17.azuredatabricks.net/?o=5011763184037517#secrets/createScope";


    useEffect(() => {
        setData(connectionData)
    }, [connectionData])
    
    if (!connectionData && !editMode) {
        return <></>
    }

    const canEnableSave = () => {
        if (editMode) {
            if (authType == "spn" && (!data.connectionName?.trim() || !data.appScope || !data.serverName?.trim() || !data.database?.trim() || !data.userName?.trim() || !data.password?.trim())) {
                return false
            }
            if (authType == "msi" && (!data.connectionName?.trim() || !data.serverName?.trim() || !data.database?.trim())) {
                return false
            }
            if (connectionData && JSON.stringify(connectionData) === JSON.stringify(data)) {
                return false
            }
            return true
        }
        return false
    }

    const onSaveClick = () => {

        var finalData = {} as SqlConnection extends Connection ? SqlConnection : Connection;
        if(authType == "spn")
            finalData = {...data, useMSI: 0};
        else
        finalData = {...data, useMSI: 1, userName: '', password: ''};

        dispatch(postConnections({ newConnection: finalData, type: connectionType }))
    }

    let subscriptionName = ''
    if (!editMode) {
        subscriptionName = subscriptions.filter(item => item.key === data.subscriptionKey)[0]?.name || ''
    }

    return ( 
        <>       
                <div className='input-row'>
                    <div>Name</div>
                    <div>
                        <TextField id = "sqlname" required disabled={!editMode} placeholder="Name" value={data.connectionName || ''} 
                        onHeInput={(e: any) => {
                            setData({...data, connectionName: e.target.value})
                            
                        }}/>
                    </div>
                </div>
                <div className='input-row'>
                    <div>Tenant</div>
                    <Select
                            value= {data.subscriptionKey || ''}
                            slot="action"
                            fixed-placement
                            disabled={!editMode}
                            placeholder={getTenantDisplayLabel(subscriptionName) || 'Select'}
                            id = "sqltenant"
                            >
                            {
                                subscriptions?.map((item) => (
                                    <Option
                                        key={item.key}
                                        role="menuitemcheckbox"
                                        value={item.key}
                                        onHeSelected={(e: any) => {
                                            setData({...data, subscriptionKey: e.target.value})
                                            
                                        }}
                                    >
                                        {getTenantDisplayLabel(item.name)}
                                    </Option>
                                ))
                            }
                        </Select>
                    </div>
                <div className='input-row'>
                    <div>App Scope
                    <Icon id="info81" name="info" style={{ marginLeft: "7px", cursor: "pointer", color: "#0078D4" }} />
                            <Tooltip anchor="info81" fixedPlacement={true} placement='bottom'> Select the app scope. If creating, then create the app scope in all the three environments. </Tooltip>
                    </div>
                    <div>
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <Select
                                value= { authType == "msi" ? data.appScope || 'nebula' : data.appScope || '' }
                                slot="action"
                                fixed-placement
                                disabled={!editMode}
                                placeholder='Select'
                                style={{width: '500px'}}
                                id = "sqlscope"
                                >
                                {
                                    appScopes?.map(item => (
                                        <Option
                                            key={item}
                                            role="menuitemcheckbox"
                                            onHeSelected={(e: any) => {
                                                setData({...data, appScope: e.target.textContent})
                                                
                                            }}
                                        >
                                            {item}
                                        </Option>
                                    ))
                                }
                            </Select>
                            {/* TODO add this to aka.ms */}
                            {
                                selectedEnv == "dev" ? <a id="sqldevscope" style={{marginLeft: '10px'}} target="_blank" href={adbScopeDev}>Add New Scope</a> 
                                : selectedEnv == "uat" ? <a id="sqluatscope" style={{marginLeft: '10px'}} target="_blank" href={adbScopUat}>Add New Scope</a> 
                                : selectedEnv == "prod" ? <a id="sqlprodscope" style={{marginLeft: '10px'}} target="_blank" href={adbScopProd}>Add New Scope</a> 
                                : <a id="sqldevscope" style={{marginLeft: '10px'}} target="_blank" href={adbScopeDev}>Add New Scope</a>
                            }
                            <Icon id="infoaddscopesql" name="info" style={{ marginLeft: "4px", cursor: "pointer", color: "#0078D4" }} tabIndex={0}/>
                            <Tooltip anchor="infoaddscopesql" fixedPlacement={true} placement='bottom'>
                            The new scope needs to be created in all the three environments
                            </Tooltip>
                        </div>
                    </div>
                </div>
                <div className='input-row'>
                    <div>Server Name
                    <Icon id="info82" name="info" style={{ marginLeft: "7px", cursor: "pointer", color: "#0078D4" }} />
                            <Tooltip anchor="info82" fixedPlacement={true} placement='bottom'> Select the server name</Tooltip>
                   
                    </div>
                    <div><TextField id = "sqlserver" required disabled={!editMode} placeholder="Server Name" value={data.serverName || ''} onHeInput={(e: any) => {
                            setData({...data, serverName: e.target.value})
                            
                        }}/>
                    </div>
                </div>
                <div className='input-row'>
                    <div>Database
                    <Icon id="info83" name="info" style={{ marginLeft: "7px", cursor: "pointer", color: "#0078D4" }} />
                            <Tooltip anchor="info83" fixedPlacement={true} placement='bottom'> Select the Database </Tooltip>
                   
                    </div>
                    <div><TextField id = "sqldatabase" required disabled={!editMode} placeholder="Database" value={data.database || ''} onHeInput={(e: any) => {
                        setData({...data, database: e.target.value})
                            
                    }}/>
                    </div>
                </div>
                {authType == "spn" &&
                <div className='input-row'>
                    <div>Username
                    <Icon id="info84" name="info" style={{ marginLeft: "7px", cursor: "pointer", color: "#0078D4" }} />
                            <Tooltip anchor="info84" fixedPlacement={true} placement='bottom'> Select the Username </Tooltip>
                   
                    </div>
                    <div><TextField id = "sqlusername" required disabled={!editMode} placeholder="UserName" value={data.userName || ''} 
                        onHeInput={(e: any) => {
                            setData({...data, userName: e.target.value})
                            
                        }}/>
                    </div>
                </div>
            }
            {authType == "spn" &&
                <div className='input-row'>
                    <div>Password
                    <Icon id="info85" name="info" style={{ marginLeft: "7px", cursor: "pointer", color: "#0078D4" }} />
                            <Tooltip anchor="info85" fixedPlacement={true} placement='bottom'> Select the password </Tooltip>
                   
                    </div>
                    <div><TextField id = "sqlpassword" required disabled={!editMode} placeholder="Password" value={data.password || ''} 
                        onHeInput={(e: any) => {
                            setData({...data, password: e.target.value})
                            
                        }}/>
                    </div>
                </div>
            }
            <div slot="footer" className="panel-footer">
                <Button id = "sqlsave" onClick={onSaveClick} disabled={!canEnableSave()} appearance={editMode ? 'primary': undefined}>
                    Save
                </Button>
            </div>
        </>     
    )
}
export const SqlConnectionPanel = withErrorBoundary("Sql Connection Panel", SqlConnectionPanelC);